module.exports = __webpack_public_path__ + "static/mr-cd48f29d4dcf088fd9a4087c8671190b.mp4";